// extracted by mini-css-extract-plugin
module.exports = {"general":"style_general__3BBXO","cross":"style_cross__2__UJ","imgModal":"style_imgModal__3h53w"};